import { render, staticRenderFns } from "./myScroll.vue?vue&type=template&id=27a16412&scoped=true&"
import script from "./myScroll.vue?vue&type=script&lang=js&"
export * from "./myScroll.vue?vue&type=script&lang=js&"
import style0 from "./myScroll.vue?vue&type=style&index=0&id=27a16412&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27a16412",
  null
  
)

export default component.exports